import type { ReactNode } from 'react';

import { PortalFadeIn } from '@/modules/portal/components/ui/portal-motion';
import { Icons } from '@/shared/components/ui/icons';
import { cn } from '@/shared/lib/cn';

interface PortalGuidanceBannerProps {
  title: string;
  message: string;
  icon?: ReactNode;
  variant?: 'info' | 'warning';
  className?: string;
}

export function PortalGuidanceBanner({
  title,
  message,
  icon,
  variant = 'info',
  className,
}: PortalGuidanceBannerProps) {
  const tone =
    variant === 'warning' ? 'border-amber-500/30 bg-amber-500/5' : 'border-primary/25 bg-primary/5';

  return (
    <PortalFadeIn delay={0.04}>
      <div
        className={cn(
          'portal-glass-panel flex gap-4 rounded-2xl border p-5 sm:p-6',
          tone,
          className,
        )}
        role="status"
      >
        <span
          className={cn(
            'flex h-11 w-11 shrink-0 items-center justify-center rounded-xl',
            variant === 'warning' ? 'bg-amber-500/15 text-amber-700' : 'bg-primary/10 text-primary',
          )}
          aria-hidden
        >
          {icon ?? <Icons.RefreshCw className="h-5 w-5" />}
        </span>
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-foreground">{title}</p>
          <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{message}</p>
        </div>
      </div>
    </PortalFadeIn>
  );
}
